(function() {
  "use strict";

  angular
    .module("app")
    .controller("DomainSelectorController", [
      "$scope",
      "$attrs",
      "$location",
      "CommunitiesService",
      "DomainSelectorService",
      "LoadingService",
      DomainSelectorController
    ]);

  function DomainSelectorController(
    $scope,
    $attrs,
    $location,
    CommunitiesService,
    DomainSelectorService,
    LoadingService
  ) {
    // We receive domain border color data from the API as a hex code
    // Need to convert that to RGBA for hover styling
    var hexToRgba = function(hex, opacity) {
      hex = hex.replace("#", "");
      var r = parseInt(hex.substring(0, 2), 16);
      var g = parseInt(hex.substring(2, 4), 16);
      var b = parseInt(hex.substring(4, 6), 16);

      return "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
    };

    // Domain tab is clicked
    $scope.selectDomain = function(domain) {
      var domainLoadingId = LoadingService.taskStart(
        $scope,
        "Loading Domain Data"
      );

      DomainSelectorService.getDomainById(domain, $attrs.assetMap).then(
        function(response) {
          LoadingService.taskEnd($scope, domainLoadingId);
          $scope.state.selectedDomain = response.data;

          $location.search("domain", $scope.state.selectedDomain.id);

          if ($attrs.assetMap) {
            // Domains should default to the Risk Ranking indicator
            // But that indicator needs to be generated ourselves
            $scope.state.selectedDomain.indicators.push({
              id: $scope.state.selectedDomain.id,
              name: $scope.state.selectedDomain.name.match(/^overall.*/i)
                ? $scope.state.selectedDomain.name
                : $scope.state.selectedDomain.name + " Risk Ranking"
            });
          }

          // If there's already a year selected, check if the new domain has data for that
          // year. If so, keep that year selected; otherwise, default to the most recent year

          if ($location.search().year) {
            $scope.state.selectedYear = {
              id: +$location.search().year // coerse to int
            };
          }

          if ($scope.state.selectedYear) {
            var hasSelectedYear;

            // Run through the response data `years` array of objects to find any match
            response.data.years.filter(function(year, index, array) {
              if (year.id === $scope.state.selectedYear.id) {
                hasSelectedYear = index;
                return true;
              }
              return false;
            });

            $scope.state.selectedYear = hasSelectedYear
              ? response.data.years[hasSelectedYear]
              : response.data.years[0];
          }
          else {
            $scope.state.selectedYear = response.data.years[0];
          }

          // Map the new domain's groups to our legend colors
          $scope.legend.colorByGroup = {};
          $scope.state.selectedDomain.groups.map(function(group, index) {
            $scope.legend.colorByGroup[group] = $scope.legend.colors[index];
            return true;
          });

          if ($attrs.assetMap) {
            var communityLoadingId = LoadingService.taskStart(
              $scope,
              "Loading Community Data"
            );
            CommunitiesService.getCommunityData(
              $scope.state.selectedDomain.id,
              $scope.state.selectedYear.id,
              true
            ).then(
              function(response) {
                LoadingService.taskEnd($scope, communityLoadingId);
                var oldCommunityRanks = $scope.state.communitiesByRank;
                $scope.state.selectedCommunities.build(
                  response.communityDistrictData,
                  oldCommunityRanks
                );

                // Domains should default to the Risk Ranking indicator
                // As a fall-back, default the default (ha) to the last indicator (usually Risk Ranking)
                var newIndicator =
                  $scope.state.selectedDomain.indicators[
                    $scope.state.selectedDomain.indicators.length - 1
                  ];

                $scope.state.selectedDomain.indicators.forEach(function(
                  indicator
                ) {
                  // Indicator id for Risk Ranking is just the domain ID
                  if (indicator.id === $scope.state.selectedDomain.id) {
                    newIndicator = indicator;
                  }
                });

                if ($scope.state.selectedIndicator) {
                  // If there already a selected indicator, and the new domain also shares that indicator,
                  // don't update the indicator. Otherwise, default to Risk Ranking.
                  if (
                    $scope.state.selectedDomain.indicators.indexOf(
                      $scope.state.selectedIndicator
                    ) === -1
                  ) {
                    $scope.state.selectedIndicator = newIndicator;
                  }
                }
                else {
                  $scope.state.selectedIndicator = newIndicator;
                }

                $scope.state.refreshLegend();

                // Now that we have all the community data we need, render that map
                $scope.rrMap.render();
              },
              function(response) {
                console.warn("getCommunityData failed!");
              }
            );
          }
        },
        function(response) {
          console.warn("getDomainById failed!");
        }
      );
    };

    $scope.setDomainHoverState = function(domainIndex, isHovered) {
      $scope.domains[domainIndex].isHovered = isHovered;
    };

    $scope.domainBorderStyle = function(domainIndex) {
      var thisDomain = $scope.domains[domainIndex]; // Sugar

      // If the domain is selected, give it the full color border, hovering or not
      if (
        $scope.state.selectedDomain &&
        $scope.state.selectedDomain.id === thisDomain.id
      ) {
        return "#" + thisDomain.color;
      }

      // If a domain isn't selected, but is hovered, give it a colored border at 40% opacity
      if (thisDomain.isHovered) {
        return hexToRgba(thisDomain.color, 40);
      }

      // Otherwise, just return nothing / no style changes
      return "";
    };

    var init = function() {
      // `window.ccc` is set in index.cshtml, populated from data provided by the view model
      // Prevents an unnecessary API request
      $scope.domains = window.ccc.domains;

      // Creating a `state` object on ``$scope` makes it easier for nested directives to
      // access our app-wide state via JS prototypal inheritance, without resorting to `$parent`.
      $scope.state = {};

      $scope.state.domainsByName = {};
      $scope.domains.map(function(domain) {
        $scope.state.domainsByName[domain.name] = domain;
        return true;
      });

      // If the user hasn't specified a domain, default to Overall Risk Ranking
      if ($location.search().domain) {
        var defaultDomainIndex = 0;
        var domainId = $location.search().domain;
        $scope.domains.forEach(function(domain, ind, arr) {
          if (domain.id == domainId) {
            defaultDomainIndex = ind;
          }
        });
        $scope.selectDomain($scope.domains[defaultDomainIndex]);
      }
      else {
        $scope.selectDomain($scope.domains[0]);
      }
    };

    // Ready, set, go!
    init();
  }
})();
